import { call, put } from 'redux-saga/effects';

import { IGetAccessCodeResponse } from 'api/components/Auth/types';
import api from 'api';

import { getAppAccessCodeFailure, getAppAccessCodeSuccess } from '../actions';

import { sendAnalyticAccessCodeError } from 'services/Analytics/trackers/accessCode';

import { LS_KEYS } from 'helpers/localStorage';

export function* getAppAccessCodeSaga() {
    try {
        const payload: IGetAccessCodeResponse = yield call(api.auth.getAppAccessCode);

        yield put(getAppAccessCodeSuccess(payload));

        localStorage.setItem(LS_KEYS.appAccessCode, JSON.stringify(payload));
    } catch (error: any) {
        yield put(getAppAccessCodeFailure());
        yield call(sendAnalyticAccessCodeError, error.message || 'Error fetching access code');
    }
}
